import React from 'react'
import FloatFormatter from './FloatFormatter'

export default function CurrencyFormatter(props) {
  const { value, currency='' } = props
  return (
    <><FloatFormatter value={value}/>&nbsp;{currency.toUpperCase()}</>
  )
}
